import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import SecondaryMarketTableSC, {
  PaginationWrapSC,
  AdditionalTopSC,
  EmptySC,
} from './secondary-market-table.styled';
import { BodyText, SmallText } from '../typography';
import SecondaryMarketItem from './secondary-market-item';
import { ReactComponent as LeftArrow } from '../../assets/img/svg/left-arrow.svg';
import { ReactComponent as RightArrow } from '../../assets/img/svg/right-arrow.svg';
import dlt from '../../utils/default-lang';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import useWindowSize from '../../utils/screen-size';
import { BP_TABLET_MIN } from '../../assets/styles/breakpoints';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import WishmakerModal from '../ui/modal/modal';
import SmsVerification from '../sms-verification';
import SuccessModal from '../success-modal';
import BuyModal from './buy-modal';
import Button from '../ui/button';
import { ROUTE_INVESTMENTS } from '../../constants';
import BidModal from './bid-modal';
import WarningModal from '../warning-modal';
import ErrorModal from '../error-modal';

const _SecondaryMarketTable = ({
  maxRows,
  hasPagination,
  hasAdditionalTop,
  hasLinkOnAll,
  instruction,
  sendSms,
  buySecondaryMarketOffer,
  bidSecondaryMarketOffer,
  history,
  getInvestorSecondaryMarket,
  secondaryMarket,
  getInvestorBiddings,
  getInvestorDashboardData,
  navigation,
  biddings,
}) => {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;
  const [additionalData, setAdditionalData] = useState({});
  const [isSmsModalOpened, setSmsModalOpened] = useState(false);
  const [isSuccessModalOpened, setSuccessModalOpened] = useState(false);
  const [isOfferClosedModalOpened, setOfferClosedModalOpened] = useState(false);
  const [isResourcesErrorModalOpened, setResourcesErrorModalOpened] = useState(false);
  const [formattedData, setFormattedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSmsCodeError, setIsSmsCodeError] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const [isBuyModalOpened, setIsBuyModalOpened] = useState(false);
  const [isBidModalOpened, setIsBidModalOpened] = useState(false);
  const [offerDetail, setOfferDetail] = useState({});
  const [bidAmount, setBidAmount] = useState('');
  const [warnModalHeadline, setWarnModalHeadline] = useState('');

  const itemsPerPage = 8;

  const fetch = useCallback(
    (page) => {
      const paginationData = {
        page: page || 1,
        per_page: itemsPerPage,
      };

      const onBadResponse = () => {
        console.log('error');
      };

      const onSuccess = () => {
        setIsLoading(false);
      };

      getInvestorSecondaryMarket({ data: paginationData, onSuccess, onBadResponse });
    },
    [getInvestorSecondaryMarket]
  );

  /* Call data on start */
  useEffect(() => {
    fetch();
  }, [fetch]);

  useEffect(() => {
    let formattedDataArray = [];
    if (maxRows) {
      formattedDataArray = secondaryMarket.items.slice(0, maxRows);
    } else {
      formattedDataArray = secondaryMarket.items;
    }
    setFormattedData(formattedDataArray);
  }, [maxRows, secondaryMarket]);

  /* Table pagination */
  const onArrowClick = (type) => {
    let formattedData = {
      per_page: itemsPerPage,
    };
    switch (type) {
      case 'next':
        formattedData = {
          page: (secondaryMarket.pagination.current_page += 1),
          ...formattedData,
        };
        break;
      case 'back':
        formattedData = {
          page: (secondaryMarket.pagination.current_page -= 1),
          ...formattedData,
        };
        break;
      default:
        break;
    }

    const onBadResponse = () => {
      setIsLoading(true);
      formattedData = {
        page: secondaryMarket.pagination.current_page,
        ...formattedData,
      };
      setTimeout(() => {
        sendTablePagination();
      }, 10000);
    };

    const onSuccess = () => {
      setIsLoading(false);
    };

    const sendTablePagination = async () => {
      await getInvestorSecondaryMarket({ data: formattedData, onSuccess, onBadResponse });
      setIsLoading(true);
    };
    sendTablePagination();
  };

  /* Send sms */
  const onSmsSend = (smsType) => {
    if (smsType) {
      sendSms({ type: smsType });
    } else {
      switch (additionalData.type) {
        case 'buy':
          sendSms({ type: 'buy' });

          break;
        case 'bid':
          sendSms(/* { type: 'bid-offer' } */);
          break;

        default:
          sendSms(/* { type: 'bid-offer' } */);
          break;
      }
    }
  };

  /* On buy offer click */
  const onBuyClick = (offerData) => {
    setOfferDetail(offerData);
    setIsBuyModalOpened(true);
  };

  const onBidClick = (offerData) => {
    setOfferDetail(offerData);
    setIsBidModalOpened(true);
  };

  const onBuyModalSubmit = (offerId) => {
    setIsBuyModalOpened(false);
    setAdditionalData({ offerId: offerId, type: 'buy' });
    onSmsSend('buy');
    setSmsModalOpened(true);
  };

  const onBidModalSubmit = (offerId, bidAmount) => {
    setBidAmount(bidAmount);
    setIsBidModalOpened(false);
    setAdditionalData({ offerId: offerId, type: 'bid' });
    onSmsSend('make-bid');
    setSmsModalOpened(true);
  };

  /* SMS Confirmation of cancel offer call */
  const onSmsModalSubmit = (smsModalData) => {
    const onBadSmsCode = () => {
      setIsSending(false);
      setIsSmsCodeError(true);
    };
    const onSuccess = () => {
      setIsSending(false);
      setSmsModalOpened(false);
      setSuccessModalOpened(true);
    };

    const onError = () => {
      setIsSending(false);
      setIsLoading(false);
    };

    const onOfferClosedError = (code) => {
      setIsSending(false);
      setSmsModalOpened(false);
      setOfferClosedModalOpened(true);

      if (code === 'NOT_YOUR_TURN') {
        setWarnModalHeadline('investor_secondary_market_not_your_turn_error_headline');
      } else if (code === 'NOT_ENOUGH_FREE_RESOURCES') {
        setWarnModalHeadline('investor_secondary_market_offer_error_resources');
      } else {
        setWarnModalHeadline('investor_secondary_market_offer_closed_error_headline');
      }
    };

    const onResourcesError = () => {
      setIsSending(false);
      setSmsModalOpened(false);
      setResourcesErrorModalOpened(true);
    };

    const onBidSuccess = () => {
      setIsSending(false);
      setSmsModalOpened(false);
      setSuccessModalOpened(true);
    };

    if (smsModalData.type === 'buy') {
      const onBuyOffer = async () => {
        await buySecondaryMarketOffer({
          data: { sms_code: smsModalData.sms_code },
          offer: smsModalData.offerId,
          onSuccess,
          onBadSmsCode,
          onOfferClosedError,
          onResourcesError,
          onError,
        });
        setIsSending(true);
      };
      onBuyOffer();
    }
    if (smsModalData.type === 'bid') {
      const onBidOffer = async () => {
        await bidSecondaryMarketOffer({
          data: {
            sms_code: smsModalData.sms_code,
            value: Number(bidAmount.replace(/ /g, '').replace(/,/g, '.')),
          },
          offer: smsModalData.offerId,
          onSuccess: () => onBidSuccess(),
          onBadSmsCode,
          onOfferError: onOfferClosedError,
          onError,
        });
        setIsSending(true);
      };
      onBidOffer();
    }
  };

  /* Call refreshed data after success call */
  const callRefreshedData = () => {
    const onBadResponse = () => {
      setIsSending(false);
      console.log('error');
    };

    const onSuccess = () => {
      setIsLoading(false);
    };

    fetch(secondaryMarket.pagination.current_page);
    getInvestorBiddings({
      data: {
        page: biddings.pagination.current_page,
        per_page: biddings.pagination.per_page,
      },
      onSuccess,
      onBadResponse,
    });
  };

  /* After success modal close call refresh data */
  const onCloseSuccess = () => {
    setSuccessModalOpened(false);
    callRefreshedData();
  };

  const onCloseOfferClosedError = () => {
    setOfferClosedModalOpened(false);
    getInvestorSecondaryMarket({
      data: {
        page: secondaryMarket.pagination.current_page,
        per_page: secondaryMarket.pagination.per_page,
      },
    });
    getInvestorBiddings({
      data: {
        page: biddings.pagination.current_page,
        per_page: biddings.pagination.per_page,
      },
    });
    getInvestorDashboardData();
  };

  const onCloseResourcesErrorModal = () => {
    setResourcesErrorModalOpened(false);
    getInvestorSecondaryMarket({
      data: {
        page: secondaryMarket.pagination.current_page,
        per_page: secondaryMarket.pagination.per_page,
      },
    });
    getInvestorBiddings({
      data: {
        page: biddings.pagination.current_page,
        per_page: biddings.pagination.per_page,
      },
    });
    getInvestorDashboardData();
  };

  const redirectToMyInvestments = () => {
    history.push(ROUTE_INVESTMENTS);
  };

  if (!formattedData.length) {
    return (
      <EmptySC full={biddings.items?.length === 0}>
        <div className="empty-table">
          <SmallText className="black-transparent bold">
            <FormattedMessage
              id="investor_secondary_market_table_empty"
              defaultMessage={dlt['investor_secondary_market_table_empty']}
            />
          </SmallText>
        </div>
      </EmptySC>
    );
  }

  return (
    <>
      <WishmakerModal
        isOpened={isSuccessModalOpened}
        onClose={() => onCloseSuccess()}
        className="special"
        withCross
      >
        <SuccessModal
          headlineText={
            additionalData.type === 'buy'
              ? 'investor_secondary_market_success_modal_headline'
              : 'investor_secondary_market_success_modal_bid_headline'
          }
        >
          {additionalData.type === 'buy' ? (
            <>
              <BodyText>
                <FormattedHTMLMessage
                  id="investor_secondary_market_success_modal_copy"
                  defaultMessage={dlt['investor_secondary_market_success_modal_copy']}
                />
              </BodyText>
              <Button type="LINK" onClick={() => redirectToMyInvestments()}>
                <FormattedMessage
                  id="investor_secondary_market_success_modal_btn"
                  defaultMessage={dlt['investor_secondary_market_success_modal_btn']}
                />
              </Button>
              .{' '}
            </>
          ) : null}
        </SuccessModal>
      </WishmakerModal>

      <WishmakerModal
        isOpened={isOfferClosedModalOpened}
        onClose={onCloseOfferClosedError}
        className="special"
        withCross
      >
        <WarningModal headlineText={warnModalHeadline} />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isResourcesErrorModalOpened}
        onClose={onCloseResourcesErrorModal}
        className="special"
        withCross
      >
        <ErrorModal headlineText="investor_secondary_market_resources_error_headline" />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isSmsModalOpened}
        onClose={() => {
          setSmsModalOpened(false);
          setIsSending(false);
        }}
        className="special"
        withCross
      >
        <SmsVerification
          onSubmit={(data) => onSmsModalSubmit(data)}
          additionalData={additionalData}
          isError={isSmsCodeError}
          isSending={isSending}
          onResend={() => onSmsSend()}
          onBadSms={() => setIsSmsCodeError(false)}
        />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isBuyModalOpened}
        onClose={() => {
          setIsBuyModalOpened(false);
        }}
        className="special"
        withCross
      >
        <BuyModal
          type="secondary-market"
          offerDetail={offerDetail}
          onSubmit={(offerId) => onBuyModalSubmit(offerId)}
          instruction={instruction}
        />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isBidModalOpened}
        onClose={() => setIsBidModalOpened(false)}
        className="special"
        withCross
      >
        <BidModal
          offerDetail={offerDetail}
          onSubmit={(offerId, bidAmount) => onBidModalSubmit(offerId, bidAmount)}
          instruction={instruction}
          type="buy"
        />
      </WishmakerModal>

      {hasAdditionalTop ? (
        <AdditionalTopSC>
          <BodyText className="bolder">
            <FormattedMessage
              id="investor_secondaryMarket_table_headline"
              defaultMessage={dlt['investor_secondaryMarket_table_headline']}
            />
          </BodyText>
          <div className="line-separator"></div>
        </AdditionalTopSC>
      ) : null}
      <SecondaryMarketTableSC>
        {isTablet ? null : (
          <thead>
            <tr>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_secondary_market_table_name"
                    defaultMessage={dlt['investor_secondary_market_table_name']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_secondary_market_table_date"
                    defaultMessage={dlt['investor_secondary_market_table_date']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_secondary_market_table_payments"
                    defaultMessage={dlt['investor_secondary_market_table_payments']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FormattedHTMLMessage
                      id="investor_secondary_market_table_value_value"
                      defaultMessage={dlt['investor_secondary_market_table_value_value']}
                      tagName="div"
                    />
                    <div
                      style={{
                        width: 1,
                        transform: 'rotate(15deg)',
                        margin: 'auto 10px',
                        background: 'rgba(47,46,65,0.6)',
                        height: 25,
                      }}
                    >
                      {/* &nbsp;/&nbsp; */}
                    </div>
                    <FormattedHTMLMessage
                      id="investor_secondary_market_table_value_offered"
                      defaultMessage={dlt['investor_secondary_market_table_value_offered']}
                      tagName="div"
                    />
                  </div>
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_secondary_market_table_future_value"
                    defaultMessage={dlt['investor_secondary_market_table_future_value']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_secondary_market_table_rate"
                    defaultMessage={dlt['investor_secondary_market_table_rate']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_secondary_market_table_price"
                    defaultMessage={dlt['investor_secondary_market_table_price']}
                  />
                </SmallText>
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>
        )}

        <tbody>
          {formattedData.map((item) => {
            return (
              <SecondaryMarketItem
                key={item.id}
                id={item.id}
                investmentId={item.investmentId}
                isTablet={isTablet}
                onBuyClick={() => onBuyClick(item)}
                onBidClick={() => onBidClick(item)}
                hasPagination={hasPagination}
                name={item.debtor.wmNumber}
                loanSignedAt={item.loanSignedAt}
                installmentCount={item.installmentCount}
                paidInstallmentCount={item.paidInstallmentCount}
                value={Number(item.value)}
                futureValue={Number(item.futureValue)}
                price={Number(item.price)}
                interestRate={Number(item.interestRate) * 100}
                isInArrears={item.isInArrears}
                alreadyBidding={item.already_bidding}
                offered={Number(item.offered_value || 0)}
              />
            );
          })}
        </tbody>
      </SecondaryMarketTableSC>

      {hasPagination ? (
        <PaginationWrapSC>
          <BodyText className="bolder orange">
            {secondaryMarket.pagination.from}-{secondaryMarket.pagination.to}{' '}
            <FormattedMessage id="global_from" defaultMessage={dlt['global_from']} />{' '}
            {secondaryMarket.pagination.total}
          </BodyText>
          <div className="arrow-wrap">
            <button
              disabled={secondaryMarket.pagination.current_page < 2 || isLoading}
              onClick={() => onArrowClick('back')}
            >
              <LeftArrow />
            </button>
            <button
              disabled={
                secondaryMarket.pagination.current_page === secondaryMarket.pagination.last_page ||
                isLoading
              }
              onClick={() => onArrowClick('next')}
            >
              <RightArrow />
            </button>
          </div>
        </PaginationWrapSC>
      ) : null}
    </>
  );
};

_SecondaryMarketTable.propTypes = {
  maxRows: PropTypes.number,
  hasPagination: PropTypes.bool,
  hasAdditionalTop: PropTypes.bool,
};

_SecondaryMarketTable.defaultProps = {
  maxRows: null,
  hasPagination: false,
  hasAdditionalTop: false,
};

const mapStateToProps = (state) => {
  return {
    secondaryMarket: state.secondary_market,
    instruction: state.instruction,
    biddings: state.biddings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      sendSms: ActionCreators.sendSms,
      getInvestorSecondaryMarket: ActionCreators.getInvestorSecondaryMarket,
      buySecondaryMarketOffer: ActionCreators.buySecondaryMarketOffer,
      bidSecondaryMarketOffer: ActionCreators.bidSecondaryMarketOffer,
      getInvestorBiddings: ActionCreators.getInvestorBiddings,
      getInvestorDashboardData: ActionCreators.getInvestorDashboardData,
    },
    dispatch
  );
};

const SecondaryMarketTable = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(_SecondaryMarketTable)
);

export default SecondaryMarketTable;
